import { Text } from '@chakra-ui/react'

/**
 * Red asterisk next to a question the survey refuses to move past until it is
 * answered — see the `required` flag on the questionnaire items.
 */
export function RequiredMark() {
  return (
    <Text as="span" color="red.500" aria-hidden="true">
      {' *'}
    </Text>
  )
}
